import {ChangeDetectorRef, Component, ElementRef, TemplateRef, ViewChild, ViewContainerRef, ChangeDetectionStrategy} from '@angular/core';
import {EventGateway} from "../event-gateway";
import {createPopper, Instance} from '@popperjs/core';
import {Placement} from "@popperjs/core/lib/enums";
import {CommonModule} from "@angular/common";

@Component({
    selector: 'app-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss'],
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class PopoverComponent {
  popperInstance: Instance;
  cssClass: string;
  title: string;

  @ViewChild('popover', {static: true}) popover: ElementRef;
  @ViewChild('container', {read: ViewContainerRef}) container: ViewContainerRef;

  private readonly registration: () => void;

  constructor(private eventGateway: EventGateway, private changeDetector: ChangeDetectorRef) {
    this.registration = this.eventGateway.registerLocalHandler(this);
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', (event) => {
      if (this.popover.nativeElement && !this.popover.nativeElement.contains(event.target)) {
        this.closePopover();
      }
    }, false);
    $(this.popover.nativeElement).on('click', '*', (event) => {
      if ($(event.target).attr("data-bs-toggle") === "popover") {
        this.closePopover();
      }
    });
  }

  openPopover = (event: PopoverEvent) => {
    setTimeout(() => {
      if (this.container) {
        this.container.clear();
        this.container.createEmbeddedView(event.component, {$implicit: event.data});
      }

      this.cssClass = event.cssClass;
      this.title = event.title;
      this.popperInstance = createPopper(event.reference.nativeElement, this.popover.nativeElement, {
        placement: event.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          },
        ]
      });
      setTimeout(() => this.show(), 0);
    }, 0);
  }

  closePopover = () => {
    this.hide();
  }

  ngOnDestroy(): void {
    this.registration();
  }

  show() {
    this.popover.nativeElement.setAttribute('data-show', '');
    this.popperInstance.setOptions((options) => ({
      ...options,
      modifiers: [
        ...options.modifiers,
        {name: 'eventListeners', enabled: true},
      ],
    }));

    setTimeout(() => {
      this.changeDetector.markForCheck();
      setTimeout(() => this.popperInstance.update(), 0);
    }, 0);
  }

  hide() {
    if (this.popperInstance) {
      this.popover.nativeElement.removeAttribute('data-show');
      this.popperInstance.setOptions((options) => ({
        ...options,
        modifiers: [
          ...options.modifiers,
          {name: 'eventListeners', enabled: false},
        ],
      }));
    }
  }
}

interface PopoverEvent {
  component: TemplateRef<any>;
  data?: any;
  placement: Placement;
  reference: ElementRef;
  cssClass?: string;
  title?: string;
}
